import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { genericDailogData } from 'src/app/shared/models/confirmation-modal.model';
import { AdminPortalService } from '../../service/admin-portal.service';

interface downtimeConfirmationDialogData{
  title: string;
  img: string;
  scheduleDowntime: boolean,
  startDate?: string,
  startTime?: string,
  confirmButton?: boolean
}

@Component({
  selector: 'app-downtime-confirmation-modal',
  templateUrl: './downtime-confirmation-modal.component.html',
  styleUrls: ['./downtime-confirmation-modal.component.css']
})
export class DowntimeConfirmationModalComponent{

  constructor(public dialogRef: MatDialogRef<DowntimeConfirmationModalComponent>,
      @Inject(MAT_DIALOG_DATA) public genericData : downtimeConfirmationDialogData,
        private adminPortalService : AdminPortalService) { 
  
    }
   
    onClose() {
      this.dialogRef.close({status: false});
    }

    onConfirm(){
      this.adminPortalService.endRedemptionDowntime().subscribe({
        next: (data)=>{
          this.dialogRef.close({status: true});
        },
        error: (e)=>console.log(e)
      })
    }

}
